export const INITIAL_TIMESPAN = '00:00:00';
export const INITIAL_TIMESPAN_HHMM = '00:00';
export const SCROLLBAR_MAX_WIDTH = 20;
export const CA_SCROLLBAR_MAX_WIDTH = 10;
export const DASH = '-';
